// extracted by mini-css-extract-plugin
export default {"container":"main_container__5hXP7","holder":"main_holder__+2vhc"};